import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Toast } from 'primereact/toast';
import '../../css/Pages.css';
import '../../css/ScientificCV.css';
import ScientificCVTemplate from '../../components/Profile/ScientificCV/ScientificCVTemplate';
import { generateWordHTML } from '../../utils/exportWordHelper';

const ScientificCV = () => {
    const toast = useRef(null);
    const [cvData, setCvData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isDesktop, setIsDesktop] = useState(true);

    useEffect(() => {
        const handleResize = () => setIsDesktop(window.innerWidth > 992);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const getAuthHeaders = useCallback(() => {
        return { 'Authorization': `Bearer ${localStorage.getItem('accessToken')}` };
    }, []);

    const handleLogout = useCallback(() => {
        alert("Phiên đăng nhập đã hết hạn hoặc bạn không có quyền truy cập. Vui lòng đăng nhập lại!");
        localStorage.removeItem('user');
        localStorage.removeItem('accessToken');
        window.location.href = '/login';
    }, []);

    const fetchCVData = useCallback(async () => {
        setIsLoading(true);
        try {
            const userStr = localStorage.getItem('user');
            if (!userStr) {
                toast.current.show({ severity: 'error', summary: 'Lỗi', detail: 'Chưa đăng nhập!' });
                handleLogout();
                return;
            }
            const currentUser = JSON.parse(userStr);
            const urlParams = new URLSearchParams(window.location.search);
            const queryId = urlParams.get('id');
            const targetUserId = queryId ? parseInt(queryId) : currentUser.Id;

            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/scientificcv?userId=${targetUserId}`, {
                headers: getAuthHeaders()
            });

            if (response.status === 401 || response.status === 403) {
                handleLogout();
                return;
            }

            if (response.ok) {
                const result = await response.json();
                setCvData(result);
            } else {
                toast.current.show({ severity: 'error', summary: 'Lỗi', detail: 'Không thể tải dữ liệu Lý lịch!' });
            }
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Lỗi', detail: 'Lỗi kết nối máy chủ!' });
        } finally {
            setIsLoading(false);
        }
    }, [getAuthHeaders, handleLogout]);

    useEffect(() => {
        fetchCVData();
    }, [fetchCVData]);

    const handlePrint = () => {
        window.print();
    };

    const handleDownloadWord = () => {
        const cvElement = document.querySelector('.printable-cv');
        if (!cvElement) {
            toast.current.show({ severity: 'error', summary: 'Lỗi', detail: 'Không tìm thấy nội dung để tải' });
            return;
        }

        const htmlContent = generateWordHTML(cvElement.innerHTML);

        const blob = new Blob(['\ufeff', htmlContent], { type: 'application/msword' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;

        const fullNameStr = cvData?.User ? `${cvData.User.LastName || ''} ${cvData.User.FirstName || ''}`.trim() : '';
        const fileName = fullNameStr ? `LLKH_${fullNameStr.replace(/\s+/g, '_')}.doc` : 'LyLichKhoaHoc.doc';

        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    return (
        <div className="page-container">
            <Toast ref={toast} position="top-right" />

            <div
                className="no-print page-header"
                style={isDesktop
                    ? { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }
                    : { display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '20px' }
                }
            >
                <div className="header-title">
                    <h2 style={{ textTransform: 'uppercase', ...(isDesktop ? {} : { margin: 0 }) }}>LÝ LỊCH KHOA HỌC</h2>
                </div>

                <div style={{ display: 'flex', gap: '10px', ...(isDesktop ? {} : { width: '100%', flexDirection: 'column' }) }}>
                    <button
                        className="btn-add-new"
                        style={{ backgroundColor: '#2980b9', ...(isDesktop ? {} : { width: '100%', margin: 0 }) }}
                        onClick={handleDownloadWord}
                        disabled={isLoading}
                    >
                        <i className="fa-solid fa-file-word" style={{ marginRight: '8px' }}></i> Tải lý lịch
                    </button>
                    <button
                        className="btn-add-new"
                        style={{ backgroundColor: '#27ae60', ...(isDesktop ? {} : { width: '100%', margin: 0 }) }}
                        onClick={handlePrint}
                        disabled={isLoading}
                    >
                        <i className="fa-solid fa-print" style={{ marginRight: '8px' }}></i> In lý lịch
                    </button>
                </div>
            </div>

            <div className="cv-wrapper">
                {isLoading ? (
                    <div style={{ textAlign: 'center', padding: '50px' }}>
                        <i className="fa-solid fa-circle-notch fa-spin fa-2x" style={{ color: '#3498db' }}></i>
                        <p style={{ marginTop: '10px', color: '#666' }}>Đang tổng hợp dữ liệu</p>
                    </div>
                ) : cvData && cvData.User ? (
                    <ScientificCVTemplate data={cvData} />
                ) : (
                    <div style={{ textAlign: 'center', padding: '50px', color: '#e74c3c' }}>
                        <h3>Không tìm thấy dữ liệu người dùng</h3>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ScientificCV;